import LandingReveal from '@/modules/Pages/shared/LandingReveal';

const contrasts = [
  {
    title: 'A customer can still look healthy',
    detail: 'while meaningful behavior is changing.',
  },
  {
    title: 'An account can look unhealthy',
    detail: 'without actually needing intervention.',
  },
];

export default function ReframeSection() {
  return (
    <section className="py-24 px-6 border-t border-light">
      <div className="max-w-6xl mx-auto">
        <LandingReveal className="max-w-3xl mb-12">
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-6">
            A health score tells you how a customer looks. But you need to know which ones actually need attention.
          </h2>
          <p className="landing-prose">
            ChurnSignal helps your team decide where its attention belongs based on what customers are actually doing,
            not just on health scores, alerts, and manual account reviews.
          </p>
          <p className="landing-prose">
            <b>A low health score is only a starting point.</b>
          </p>
        </LandingReveal>

        <div className="grid md:grid-cols-2 gap-5 mb-14">
          {contrasts.map((item, index) => (
            <LandingReveal
              key={item.title}
              delayClass={index === 0 ? 'landing-delay-1' : index === 1 ? 'landing-delay-2' : 'landing-delay-3'}
            >
              <div className="landing-card p-6 h-full">
                <p className="text-primary text-lg font-semibold font-secondary leading-snug mb-2">{item.title}</p>
                {item.detail ? <p className="text-secondary leading-relaxed">{item.detail}</p> : null}
              </div>
            </LandingReveal>
          ))}
        </div>

        <LandingReveal delayClass="landing-delay-1" className="max-w-3xl mx-auto text-center">
          <p className="landing-section-label mb-4">ChurnSignal helps you answer</p>
          <p className="text-xl md:text-2xl font-semibold text-primary font-secondary leading-relaxed mb-5">
            Which customers are actually at risk, why, and what should we do next?
          </p>
          <p className="landing-prose">
            The goal isn&apos;t just a better score. It&apos;s a better decision about which customers need your
            team&apos;s attention.
          </p>
        </LandingReveal>
      </div>
    </section>
  );
}
